export interface InitialPagecountsStatusModel {
  done: boolean;
  manualCollectAssetsTotal: number;
  manualCollectAssetsNotInRM: number;
  manualCollectAssetsCollected: number;
  manualCollectAssetsNotCollectedButInRM: number;
}

export function initialPagecountsStatusFactory(json?: any): InitialPagecountsStatusModel {
  json = json || {};
  return {
    done: !!json.done,
    manualCollectAssetsTotal: +json.manualCollectAssetsTotal,
    manualCollectAssetsNotInRM: +json.manualCollectAssetsNotInRM,
    manualCollectAssetsCollected: +json.manualCollectAssetsCollected,
    manualCollectAssetsNotCollectedButInRM: +json.manualCollectAssetsNotCollectedButInRM,
  };
}
